module.exports = __webpack_public_path__ + "static/media/dvd.b7936742.jpg";